export const goToPage = (
  page: number,
  setActiveStep: (step: number) => void,
) => {
  setActiveStep(page);
  window.scrollTo(0, 0);
  document.querySelector("h1")?.focus(); // wcag, new "page" reset focus
};
